/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    color: PropTypes.oneOf([
        'primary',
        'premium',
        'error',
        'secondary',
        'facebook',
        'tertiary',
    ]),
    disabled: PropTypes.bool,
    expand: PropTypes.bool,
    loading: PropTypes.bool,
    small: PropTypes.bool,
    square: PropTypes.bool,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
};

const defaultProps = {
    ...commonDefaultProps,
    color: 'primary',
    componentClass: 'button',
    disabled: false,
    expand: false,
    loading: false,
    small: false,
    square: false,
    type: 'button',
};

const Button = (props) => {
    const classNames = [
        'c-btn',
        `c-btn--${props.color}`,
        props.disabled ? 'c-btn--disabled' : '',
        props.expand ? 'c-btn--fluid' : '',
        props.loading ? 'c-btn--loading' : '',
        props.small ? 'c-btn--small' : '',
        props.square ? 'c-btn--square' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    let computedChildren = props.children;
    if (props.loading) {
        computedChildren = (
            <>
                {computedChildren}
            </>
        );
    }
    return (
        <props.componentClass
            type={props.componentClass === 'button' ? props.type : null}
            className={concatClassNames(classNames)}
            disabled={props.disabled}
            {...filterProps(propTypes, props)}
        >
            {computedChildren}
        </props.componentClass>
    );
};

Button.propTypes = propTypes;

Button.defaultProps = defaultProps;

export default Button;
